import type { TranslationKey } from './en';

export const he: Record<TranslationKey, string> = {
  title: 'צ\'אט שירות לקוחות',
  greeting: 'שלום! איך אפשר לעזור?',
  inputPlaceholder: 'כתוב הודעה...',
  inputPlaceholderEmail: 'הכנס כתובת אימייל...',
  inputPlaceholderOtp: 'הכנס קוד אימות בן 6 ספרות...',
  send: 'שלח',
  stop: 'עצור',
  attachFile: 'צרף קובץ',
  authPrompt: 'ברוכים הבאים! כדי להתחיל, אנא הכנס את כתובת האימייל שלך.',
  authOtpSent: 'שלחנו קוד אימות בן 6 ספרות ל-{email}. אנא הכנס אותו כאן.',
  authVerified: 'מאומת כ-{email}',
  authSuccess: 'הכל מוכן! איך אפשר לעזור לך היום?',
  authInvalidEmail: 'זה לא נראה ככתובת אימייל תקינה. אנא נסה שוב.',
  authInvalidOtp: 'אנא הכנס את הקוד בן 6 הספרות ששלחנו לאימייל שלך.',
  authVerifyFailed: 'הקוד לא עבד. אנא בדוק ונסה שוב.',
  authSendFailed: 'משהו השתבש בשליחת הקוד. אנא נסה שוב.',
  uploading: 'מעלה...',
  uploadError: 'ההעלאה נכשלה. נסה שוב.',
  networkError: 'החיבור נותק. מנסה שוב...',
  retry: 'נסה שוב',
  close: 'סגור',
  minimize: 'מזער',
  today: 'היום',
  yesterday: 'אתמול',
  dragDropHint: 'גרור קובץ לכאן או לחץ לבחירה',
  fileTooLarge: 'הקובץ חייב להיות מתחת ל-10MB',
  invalidFileType: 'סוג קובץ לא נתמך',
  toolCalling: 'מפעיל {tool}...',
  toolDone: 'הושלם',
  toolError: 'נכשל',
  analystStarted: 'מנתח את הנתונים...',
  analystThinking: 'מתכנן את הניתוח (שלב {round})...',
  analystQuerying: 'מריץ חישובים (שלב {round})...',
  analystSaving: 'בודק את התוצאה...',
  analystFixing: 'משפר את החישוב...',
  chatError: 'מצטערים, אירעה שגיאה. אנא נסה שוב.',
  chatTimeout: 'הבקשה נמשכה יותר מדי זמן. אנא נסה שוב.',
  dismiss: 'בטל',
  mcpConnecting: 'מתחבר לכלים...',
  mcpConnected: 'כלים מוכנים',
  mcpFailed: 'לא ניתן להתחבר לכלים',
  formSubmit: 'שלח',
  formCancel: 'ביטול',
  formApprove: 'אישור',
  formReject: 'דחייה',
  confirmationTitle: 'אישור פעולה: {tool}',
  confirmationParamsTitle: 'הזן פרמטרים עבור: {tool}',
  confirmationApproved: 'אושר',
  confirmationRejected: 'נדחה',
  confirmationTimedOut: 'הבקשה פגה',
  formRequired: 'שדה חובה',
  authSsoButton: 'התחבר עם {provider}',
  authSsoPending: 'השלם את ההתחברות בחלון הקופץ',
  authSsoFailed: 'ההתחברות נכשלה. אנא נסה שוב.',
  authSsoCancelled: 'ההתחברות בוטלה.',
  rateLimited: 'אנא המתן רגע לפני שליחת הודעה נוספת.',
  rateLimitCountdown: 'יותר מדי הודעות. אנא המתן {seconds} שניות...',
  captchaPrompt: 'פתור כדי להמשיך:',
  captchaVerify: 'אימות',
  captchaFailed: 'תשובה שגויה. נסה שוב.',
  widgetUnavailable: 'הצ\'אט לא זמין',
  widgetUnavailableDesc: 'הצ\'אט אינו פעיל כרגע. אנא נסה שוב מאוחר יותר.',

  // Voice (regular chat)
  voiceInput: 'קלט קולי',
  voiceInputListening: 'מקשיב...',
  readAloud: 'הקרא בקול',
  stopReading: 'עצור הקראה',

  // Driving mode
  drivingMode: 'מצב נהיגה',
  drivingModeExit: 'יציאה',
  drivingModeListening: 'מקשיב...',
  drivingModeProcessing: 'מעבד...',
  drivingModeSpeaking: 'מדבר...',
  drivingModeIdle: 'מוכן',
  drivingModeTapToSpeak: 'לחץ לדיבור',
  drivingModeTapToStop: 'לחץ לעצירה',
  drivingModeEmptyResponse: 'שלח הודעה קולית כדי להתחיל',
  drivingModeGoodbye: 'להתראות! מצב הנהיגה הסתיים.',
  drivingModeRepeat: 'חזור',
  drivingModeSpeed: 'מהירות דיבור',
  drivingModeAudioOutput: 'פלט שמע',
  drivingModeAudioOutputDefault: 'ברירת המחדל של הדפדפן',
  drivingModeCueSounds: 'צלילי חיווי',
  drivingModeCueSoundsOn: 'צלילי חיווי פעילים',
  drivingModeCueSoundsOff: 'צלילי חיווי כבויים',

  // Keypad
  keypadOpen: 'מקלדת מספרים',
  keypadSend: 'שלח',
  keypadHint: 'הקלד מספר',
  keypadClose: 'סגור מקלדת',

  // Speech errors
  sttNotSupported: 'זיהוי דיבור אינו נתמך בדפדפן זה. השתמש ב-Chrome או Edge.',
  sttPermissionDenied: 'הגישה למיקרופון נדחתה. אנא אפשר גישה למיקרופון ונסה שוב.',
  sttNoSpeech: 'לא זוהה דיבור. נסה שוב.',
  sttNetworkError: 'שגיאת רשת בזיהוי דיבור.',
  sttApiKeyMissing: 'קלט קולי אינו זמין כי לא הוגדר OpenAI API key עבור זיהוי דיבור.',

  // Portal (sidebar)
  portalNewChat: 'שיחה חדשה',
  portalLoading: 'טוען...',
  portalNoConversations: 'אין שיחות קודמות',
  portalUntitledConversation: 'שיחה ללא כותרת',
  portalTurnTimedOut: 'תם הזמן',
  portalTurnError: 'שגיאה',
  portalDeleteConversation: 'מחק שיחה',
  portalGuest: 'אורח',
  portalLogout: 'יציאה',
  portalHideMenu: 'הסתר תפריט',
  portalShowMenu: 'הצג תפריט',
  portalLast7Days: '7 ימים אחרונים',
  portalOlder: 'ישן יותר',
  portalInvalidLink: 'קישור לא תקין',
  portalInvalidLinkDesc: 'קישור הצ\'אט אינו תקין. אנא בדוק את הכתובת ונסה שוב.',
};
